import { DefaultPageState } from "../../../common/models/StoreDefaultModel";

export type MachineMaterialItemData = {};

export const initialMachineMaterialPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
